const initTableRows = (rowCount, colCount) => {
  if (!rowCount) rowCount = 0;

  if (!colCount) colCount = 12;

  return Array(rowCount)
    .fill()
    .map(() =>
      Array(colCount)
        .fill()
        .map(() => 0)
    );
};

export default initTableRows;
